import DepartureTopStrip from '../components/ui/DepartureTopStrip';
import PhoneTopStrip from '../components/ui/PhoneTopStrip';
import useRenderMode from '../hooks/useRenderMode';

const AIRTEL_URL = 'https://www.airtel.in/business/commercial-communication/';

const FEATURES = [
  'Bulk SMS messaging for promotional campaigns',
  'High delivery rates across all carriers',
  'Commercial communication compliance',
  'Enterprise-grade API & integrations',
  'Real-time delivery tracking & reports',
];

const SMSBlast = () => {
  const mode = useRenderMode();

  // --- Phone mode: Departure Board phone variant -------------------------
  if (mode === 'phone') {
    return (
      <div className="db-page-phone">
        <PhoneTopStrip />

        <div className="db-ribbon-phone">
          <div className="title">SMS BLAST · <em>AIRTEL</em></div>
        </div>

        <section className="db-cta-phone">
          <div className="eyebrow">AIRTEL BUSINESS · COMMERCIAL COMMUNICATION</div>
          <p className="desc">
            Reach drivers, supervisors and customers using Airtel Business&apos;s commercial
            communication platform. Bulk SMS with enterprise-grade delivery tracking.
          </p>

          <ul className="list">
            {FEATURES.map((f) => <li key={f}>{f}</li>)}
          </ul>

          <a href={AIRTEL_URL} target="_blank" rel="noopener noreferrer" className="db-pill primary block">
            OPEN IN NEW TAB →
          </a>

          <div className="footnote">OPENS AIRTEL BUSINESS PORTAL IN A NEW TAB</div>
        </section>
      </div>
    );
  }

  // --- Desk / wall: Departure Board ---
  return (
    <div className="db-page">
      <DepartureTopStrip />

      <div className="db-ribbon">
        <div className="db-ribbon-title">
          SMS BLAST · <em>AIRTEL</em>
        </div>
      </div>

      <section style={{ padding: 'var(--sp-12) var(--pad-h)', maxWidth: 600 }}>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--c-ink-3)', fontWeight: 600, marginBottom: 'var(--sp-4)' }}>
          AIRTEL BUSINESS · COMMERCIAL COMMUNICATION
        </div>
        <p style={{ fontFamily: "'Geist', sans-serif", fontSize: 15, color: 'var(--c-ink-2)', lineHeight: 1.6, margin: '0 0 var(--sp-6)' }}>
          Reach drivers, supervisors and customers using Airtel Business&apos;s commercial
          communication platform. Bulk SMS with enterprise-grade delivery tracking.
        </p>

        <ul style={{ listStyle: 'none', margin: '0 0 var(--sp-8)', padding: 0, display: 'flex', flexDirection: 'column', gap: 0 }}>
          {FEATURES.map((f) => (
            <li key={f} style={{ fontFamily: "'Geist', sans-serif", fontSize: 14, color: 'var(--c-ink-2)', padding: '8px 0', borderBottom: '1px solid var(--c-line-soft)' }}>
              {f}
            </li>
          ))}
        </ul>

        <a href={AIRTEL_URL} target="_blank" rel="noopener noreferrer" className="db-pill primary" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          OPEN IN NEW TAB →
        </a>

        <p style={{ fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '.10em', color: 'var(--c-ink-4)', marginTop: 'var(--sp-4)' }}>
          OPENS AIRTEL BUSINESS PORTAL IN A NEW TAB
        </p>
      </section>
    </div>
  );
};

export default SMSBlast;
